export default __webpack_public_path__ + "static/media/hero-text.91a6d2f7.png";